import { Configuration, ProfitCentersApi } from "../../generated-client";
import "reflect-metadata";

export class ProfitCenterClient {
	public profitCentersApi: ProfitCentersApi;

	constructor() {
		const basePath =
			window.BACKEND_URL || location.origin || "http://localhost:3000";
		const config = new Configuration({
			basePath: basePath,
			accessToken: () => sessionStorage.getItem("jwt") || "",
		});
		this.profitCentersApi = new ProfitCentersApi(config);
	}
}
